import { render, staticRenderFns } from "./producer_all_products.vue?vue&type=template&id=143a777c&scoped=true"
import script from "./producer_all_products.vue?vue&type=script&lang=js"
export * from "./producer_all_products.vue?vue&type=script&lang=js"
import style0 from "./producer_all_products.vue?vue&type=style&index=0&id=143a777c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a777c",
  null
  
)

export default component.exports